<script>
import Multiselect from 'vue-multiselect'

import { apiSecond } from '@/boot/axios'

export default {
	name: 'ZpmIndex',
	components: {
		Multiselect,
	},
	data() {
		const statusOptions = [
			{ value: '', label: this.$t('filters.status_all') },
			{ value: 'active', label: this.$t('zpm.status_active') },
			{ value: 'inactive', label: this.$t('zpm.status_inactive') },
		]
		return {
			statusOptions,
			selectedStatus:
				statusOptions.find((o) => o.value === (this.$route.query.status || '')) || statusOptions[0],
			headers: [
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '90px',
				},
				{ text: 'Id', value: 'id', width: '50px' },
				{ text: this.$t('headers.zpm_nikad'), value: 'zpm_nikad', width: '160px' },
				{ text: this.$t('headers.iin_bin'), value: 'bin', width: '120px' },
				{ text: this.$t('zpm.title'), value: 'title', width: '220px' },
				{ text: this.$t('headers.status'), value: 'status', width: '100px' },
				{ text: this.$t('headers.start_date'), value: 'start_date', width: '120px' },
				{ text: this.$t('headers.end_date'), value: 'end_date', width: '120px' },
				{ text: `${this.$t('headers.zpm_capacity')}`, value: 'total_capacity', width: '140px' },
				{ text: `${this.$t('headers.remainder')}`, value: 'total_remainder', width: '120px' },
				{ text: this.$t('zpm.transferred'), value: 'transferred_at', width: '140px' },
			],
			list: [],
			totals: 0,
			loading: false,
			// фильтры (контракт ЗПМ: bin, zpm_nikad, title, status)
			filters: {
				bin: this.$route.query.bin || '',
				zpm_nikad: this.$route.query.zpm_nikad || '',
				title: this.$route.query.title || '',
			},
			errorMessage: {
				status: null,
				text: null,
			},
			options: {
				page: Number(this.$route?.query?.page || 1),
				itemsPerPage: Number(this.$route?.query?.per_page || 10),
			},
		}
	},
	computed: {
		query() {
			return this.$route.query
		},
	},
	watch: {
		query: {
			handler() {
				this.apiGetZpm()
			},
			immediate: true,
		},
		options: {
			handler(newOptions) {
				if (
					this.$route.query.page != newOptions.page ||
					this.$route.query.per_page != newOptions.itemsPerPage
				) {
					this.$router.replace({
						query: {
							...this.$route.query,
							page: newOptions.page,
							per_page: newOptions.itemsPerPage,
							filterTime: new Date().getTime(),
						},
					})
				}
			},
			deep: true,
		},
		'$route.query.page'(newPage) {
			if (newPage && this.options.page !== Number(newPage)) {
				this.options.page = Number(newPage)
			}
		},
		'$route.query.per_page'(newPerPage) {
			if (newPerPage && this.options.itemsPerPage !== Number(newPerPage)) {
				this.options.itemsPerPage = Number(newPerPage)
			}
		},
	},
	beforeCreate() {
		if (!localStorage.token) this.$router.push('/ru/login')
	},
	methods: {
		onOptionsUpdate(newOptions) {
			this.options.page = newOptions.page
			this.options.itemsPerPage = newOptions.itemsPerPage
		},
		statusLabel(status) {
			if (!status) return '-'
			const key = 'zpm.status_' + status
			return this.$te(key) ? this.$t(key) : status
		},
		formatDate(date) {
			if (!date) return '-'
			const parts = String(date).slice(0, 10).split('-')
			if (parts.length !== 3) return date
			return `${parts[2]}.${parts[1]}.${parts[0]}`
		},
		search() {
			this.$router.replace({
				query: {
					...this.$route.query,
					page: 1,
					bin: this.filters.bin || undefined,
					zpm_nikad: this.filters.zpm_nikad || undefined,
					title: this.filters.title || undefined,
					status: this.selectedStatus?.value || undefined,
					filterTime: new Date().getTime(),
				},
			})
		},
		resetFilters() {
			this.filters = { bin: '', zpm_nikad: '', title: '' }
			this.selectedStatus = this.statusOptions[0]
			this.search()
		},
		catchError(error) {
			if (error?.response?.status == 500) {
				this.errorMessage.status = 500
				this.errorMessage.text = this.$t('system_message.500')
			}
			if (error?.response?.status == 401) {
				this.errorMessage.status = 401
				this.errorMessage.text = error.response.data.error_message
				this.$router.push('/' + this.$i18n.locale + '/login')
			}
			if (error?.response?.status == 422) {
				this.errorMessage.status = 422
				this.errorMessage.text = error.response.data.message || error.response.data.error_message
			}
			if (error?.response?.status == 403) {
				this.errorMessage.status = 403
				this.errorMessage.text = error?.response?.data?.message
			}
		},
		async apiGetZpm() {
			try {
				this.loading = true
				const params = {
					page: this.$route?.query?.page || 1,
					per_page: this.$route?.query?.per_page || 10,
				}
				if (this.$route.query.bin) params.bin = this.$route.query.bin
				if (this.$route.query.zpm_nikad) params.zpm_nikad = this.$route.query.zpm_nikad
				if (this.$route.query.title) params.title = this.$route.query.title
				if (this.$route.query.status) params.status = this.$route.query.status

				const response = await apiSecond.get('v1/zpm', { params })

				if (response?.data?.data) {
					this.list = response.data.data
					this.totals = response.data.total
				}
			} catch (error) {
				this.catchError(error)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{
			'wrap__content--preloader': !$store.state.userObject || !$store.getters.userPermission,
		}"
	>
		<v-preloader
			v-if="!$store.getters.userPermission || !$store.state.userObject"
			:message="errorMessage"
		></v-preloader>

		<div v-else class="container">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['Zpm']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title w-full flex flex-wrap justify-between gap-2">
									<div class="content__title--element">
										<div class="content__title--text">
											{{ $t('sidebar.zpm') }}
										</div>
									</div>
									<div class="table__filter--right">
										<router-link
											v-if="$store.getters.userPermission(['change_quota'])"
											:to="{
												path: '/' + $i18n.locale + '/account/zpm/create',
												query: { page: $route.query.page || 1 },
											}"
											class="btn--link btn--link--plus"
										>
											{{ $t('button.add_zpm') }}
											<img src="@/assets/img/icon-plus.svg" />
										</router-link>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<!-- Фильтры ЗПМ -->
									<div class="w-full row gap-y-2 mb-4">
										<div class="col-12 col-md-6 col-lg-3">
											<label class="search__label">
												<input
													v-model="filters.bin"
													type="text"
													name="filter_bin"
													:placeholder="$t('headers.iin_bin')"
													@keyup.enter="search"
												/>
											</label>
										</div>
										<div class="col-12 col-md-6 col-lg-3">
											<label class="search__label">
												<input
													v-model="filters.zpm_nikad"
													type="text"
													name="filter_zpm_nikad"
													:placeholder="$t('headers.zpm_nikad')"
													@keyup.enter="search"
												/>
											</label>
										</div>
										<div class="col-12 col-md-6 col-lg-3">
											<label class="search__label">
												<input
													v-model="filters.title"
													type="text"
													name="filter_title"
													:placeholder="$t('zpm.search_title')"
													@keyup.enter="search"
												/>
											</label>
										</div>
										<div class="col-12 col-md-6 col-lg-3">
											<div class="form__line--input">
												<Multiselect
													v-model="selectedStatus"
													:options="statusOptions"
													:searchable="false"
													:close-on-select="true"
													:show-labels="false"
													:allow-empty="false"
													:placeholder="$t('filters.status_all')"
													label="label"
													track-by="value"
													class="multiselect__check"
												/>
											</div>
										</div>
										<div class="col-12 col-md-6 col-lg-3 flex items-end gap-2">
											<button class="input-btn form__line--btn" @click="search">
												{{ $t('button.find') }}
											</button>
											<button class="btn--link btn--link--plus" @click.prevent.stop="resetFilters">
												{{ $t('button.clear') }}
											</button>
										</div>
									</div>

									<v-data-table
										:headers="headers"
										:items="list"
										:loading="loading"
										:loading-text="$t('button.loading')"
										:no-data-text="$t('system_message.no_data')"
										:no-results-text="$t('system_message.search')"
										disable-sort
										:options.sync="options"
										:server-items-length="totals"
										:footer-props="{
											'items-per-page-options': [5, 10, 20, 30, 40, 50],
										}"
										@update:options="onOptionsUpdate"
									>
										<template slot="item.status" slot-scope="{ item }">
											{{ statusLabel(item.status) }}
										</template>
										<template slot="item.start_date" slot-scope="{ item }">
											{{ formatDate(item.start_date) }}
										</template>
										<template slot="item.end_date" slot-scope="{ item }">
											{{ formatDate(item.end_date) }}
										</template>
										<template slot="item.transferred_at" slot-scope="{ item }">
											{{
												item.transferred_at
													? formatDate(item.transferred_at)
													: $t('zpm.not_transferred')
											}}
										</template>
										<template slot="item.action" slot-scope="{ item }">
											<div class="flex">
												<router-link
													:to="{
														path: '/' + $i18n.locale + '/account/zpm/' + item.id,
														query: { page: $route.query.page || 1 },
													}"
													class="tb__table--btn tb__table--show"
													v-tooltip.top-center="{
														content: $t('tooltip.look'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.75 9s3-6 8.25-6 8.25 6 8.25 6-3 6-8.25 6S.75 9 .75 9z" stroke="#5ABB5E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z" stroke="#5ABB5E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</router-link>
												<router-link
													v-if="
														!item.transferred_at && $store.getters.userPermission(['change_quota'])
													"
													:to="{
														path: '/' + $i18n.locale + '/account/zpm/' + item.id + '/edit',
														query: { page: $route.query.page || 1 },
													}"
													class="tb__table--btn tb__table--edit"
													v-tooltip.top-center="{
														content: $t('tooltip.edit'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9 15h6.75M12.375 2.625a1.591 1.591 0 112.25 2.25L5.25 14.25l-3 .75.75-3 9.375-9.375z" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</router-link>
											</div>
										</template>
										<v-alert slot="no-results" :value="true" color="error">
											{{ $t('system_message.search') }}
										</v-alert>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
